export type TimelineType = "爆料" | "发酵" | "官方回应" | "核验" | "反转";

export interface CaseTimelineItem {
  date: string;
  title: string;
  desc: string;
  type: TimelineType;
}

export interface OfficialResponse {
  org: string;
  date: string;
  content: string;
}

export interface CaseItem {
  id: string;
  slug: string;
  title: string;
  category: string;
  status: string;
  region: string;
  heat: number;
  publishDate: string;
  updateDate: string;
  cover: string;
  coverAlt: string;
  summary: string;
  verdict: string;
  conclusion: string;
  keyFacts: string[];
  timeline: CaseTimelineItem[];
  officialResponses: OfficialResponse[];
  sources: string[];
  relatedFactCheckIds: string[];
  relatedGuideIds: string[];
}

export const caseCategories = [
  "全部",
  "反转追踪",
  "官方回应",
  "辟谣速览",
  "网络传言",
  "求证实录",
];

export const caseStatuses = [
  "全部",
  "反转成立",
  "谣言证伪",
  "属实确认",
  "官方已回应",
  "待核验",
];

export const cases: CaseItem[] = [
  {
    id: "case-001",
    slug: "school-canteen-expired-food-video",
    title: "网传“某中学食堂使用过期食材”视频流出，48 小时后剧情反转",
    category: "反转追踪",
    status: "反转成立",
    region: "华东某市",
    heat: 9821,
    publishDate: "2026-08-12",
    updateDate: "2026-08-15",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20photograph%20of%20a%20clean%20school%20canteen%20kitchen%20counter%20with%20stainless%20steel%20trays%20and%20stacked%20sealed%20ingredient%20bags%20under%20soft%20daylight%2C%20muted%20warm%20tones%2C%20slightly%20desaturated%20palette%2C%20calm%20serious%20mood%2C%20no%20text%2C%20consistent%20verification%20news%20visual%20style%2C%20high%20detail%2C%20balanced%20composition&width=1200&height=750&seq=case-canteen-01&orientation=landscape",
    coverAlt: "某中学食堂后厨食材台账核验现场（示意画面）",
    summary:
      "一段标注“某中学后厨”的短视频在多个社交平台同步传播，画面中的包装日期引发大量讨论。随着校方说明、监管部门通报与第三方留样记录陆续公开，事件走向出现明显反转。",
    verdict: "反转成立",
    conclusion:
      "经核验，该视频存在两处剪辑点与时间错位，“使用过期食材”的核心指控不成立。视频中被指“过期”的包装实际属于另一批未使用的原料。事件由一起夸大传播的信息演变为典型的反转案例。",
    keyFacts: [
      "视频全长 1 分 23 秒，存在两处明显剪辑点",
      "涉事食堂所用原料批次抽样检测合格",
      "被指“过期”的包装属于另一批未投入使用原料",
      "原始爆料账号在核验结论公布后删除了视频",
    ],
    timeline: [
      {
        date: "2026-08-12 09:20",
        title: "爆料视频流出",
        desc: "一段 1 分 23 秒的短视频在多个平台同步出现，拍摄者称在某中学食堂后厨拍到“过期原料”，画面中的包装日期被反复放大。",
        type: "爆料",
      },
      {
        date: "2026-08-12 14:05",
        title: "话题快速发酵",
        desc: "视频播放量在 5 小时内突破 300 万，转发与评论中出现大量情绪化讨论，部分账号开始叠加未经证实的信息。",
        type: "发酵",
      },
      {
        date: "2026-08-13 08:30",
        title: "校方发布情况说明",
        desc: "校方称已第一时间封存相关原料并公开采购台账，配合调查，但未公布完整的后厨监控。",
        type: "官方回应",
      },
      {
        date: "2026-08-14 16:40",
        title: "监管部门通报抽样结果",
        desc: "属地市场监管部门公布抽样检测结果，所涉批次未检出过期问题，并说明视频中的“日期”实为另一批未使用原料。",
        type: "官方回应",
      },
      {
        date: "2026-08-15 10:00",
        title: "核验结论公布",
        desc: "综合台账、监控与留样记录，视频存在剪辑拼接与时间错位，原始爆料关键信息不成立，事件出现反转。",
        type: "核验",
      },
    ],
    officialResponses: [
      {
        org: "属地市场监管部门",
        date: "2026-08-14",
        content:
          "对该校食堂在库原料开展抽样检测，未发现过期原料，留样检测结果合格；已督促食堂完善进货查验与台账管理。",
      },
      {
        org: "涉事学校",
        date: "2026-08-13",
        content:
          "已第一时间封存相关原料并开放采购台账，全力配合监管部门调查，后续将主动公开整改情况。",
      },
    ],
    sources: ["校方情况说明", "监管部门抽样通报", "第三方留样记录"],
    relatedFactCheckIds: ["fc-001", "fc-004"],
    relatedGuideIds: ["guide-1", "guide-4"],
  },
  {
    id: "case-002",
    slug: "community-group-buying-vegetable-price-rumor",
    title: "“社区团购蔬菜集体涨价”截图流传，订单来源核查后证伪",
    category: "辟谣速览",
    status: "谣言证伪",
    region: "华南某区",
    heat: 6410,
    publishDate: "2026-07-28",
    updateDate: "2026-07-30",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20photograph%20of%20fresh%20seasonal%20vegetables%20arranged%20in%20paper%20bags%20beside%20a%20smartphone%20showing%20a%20blank%20grocery%20list%2C%20muted%20natural%20tones%2C%20soft%20diffused%20light%2C%20calm%20documentary%20mood%2C%20no%20readable%20text%2C%20consistent%20fact-check%20visual%20style%2C%20high%20detail%2C%20clean%20composition&width=1200&height=750&seq=case-veggie-02&orientation=landscape",
    coverAlt: "社区团购蔬菜订单与价格信息核验（示意画面）",
    summary:
      "一张汇总多家社区团购平台菜价的对比图在业主群流传，声称“集体涨价三成”。比对原始订单与平台价格记录后，图中多数价格无法对应真实订单。",
    verdict: "谣言证伪",
    conclusion:
      "对比图中至少四处价格来自不同时间段与不同规格商品，存在拼接对比。经平台订单记录与多位居民实际下单凭证核对，相关蔬菜价格未见集体上涨，“涨价三成”说法不成立。",
    keyFacts: [
      "对比图中 4 处价格来自不同日期与不同规格",
      "抽样 20 位居民的实际订单未见集体涨价",
      "图片早期版本已在多个城市群聊中被重复使用",
    ],
    timeline: [
      {
        date: "2026-07-28 11:10",
        title: "对比图在业主群流传",
        desc: "一张标注“本周菜价”的对比图出现在多个社区群，称多家团购平台蔬菜集体涨价三成。",
        type: "爆料",
      },
      {
        date: "2026-07-29 10:00",
        title: "多城市出现同款图片",
        desc: "核验人员发现同一张对比图在不同城市群聊中被反复转发，仅配文地名不同。",
        type: "发酵",
      },
      {
        date: "2026-07-30 15:20",
        title: "核验结论公布",
        desc: "对比原始订单与平台价格记录，图中价格存在时间与规格错配，“集体涨价”说法不成立。",
        type: "核验",
      },
    ],
    officialResponses: [
      {
        org: "属地市场监管部门",
        date: "2026-07-30",
        content:
          "近期辖区主要生活必需品价格总体平稳，未发现社区团购平台串通涨价情况，将持续开展价格巡查。",
      },
    ],
    sources: ["平台价格记录", "随机订单抽样", "属地市场价格巡查信息"],
    relatedFactCheckIds: ["fc-002"],
    relatedGuideIds: ["guide-2", "guide-5"],
  },
  {
    id: "case-003",
    slug: "scenic-area-price-video-response",
    title: "“景区天价餐饮”视频引发关注，景区与经营方先后作出回应",
    category: "官方回应",
    status: "官方已回应",
    region: "西南某景区",
    heat: 8120,
    publishDate: "2026-07-15",
    updateDate: "2026-07-18",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20photograph%20of%20a%20quiet%20mountain%20scenic%20area%20restaurant%20terrace%20with%20simple%20wooden%20tables%20and%20a%20chalkboard%20menu%2C%20soft%20overcast%20light%2C%20muted%20earthy%20tones%2C%20calm%20investigative%20mood%2C%20no%20readable%20text%2C%20consistent%20news%20verification%20visual%20style%2C%20high%20detail%2C%20balanced%20composition&width=1200&height=750&seq=case-scenic-03&orientation=landscape",
    coverAlt: "景区餐饮价格事件核验现场（示意画面）",
    summary:
      "一段游客拍摄的消费纠纷视频在网络传播，称景区内一餐馆“天价收费”。景区与经营方随即回应，属地部门介入核实，事件在回应中逐步清晰。",
    verdict: "官方已回应",
    conclusion:
      "经营方公开了当日菜单与点单记录，景区管理方说明已要求明码标价并公示价格牌。属地部门已介入核实，提示游客保留消费凭证。事件整体走向以官方与经营方的公开回应为主，尚无进一步反转。",
    keyFacts: [
      "争议集中在菜单标价与实际结算是否一致",
      "经营方公开了当日点单记录",
      "景区要求经营户限期完善明码标价",
    ],
    timeline: [
      {
        date: "2026-07-15 13:40",
        title: "游客视频引发关注",
        desc: "游客发布消费纠纷视频，称在景区内一餐馆遭遇“天价收费”，引发网友讨论。",
        type: "爆料",
      },
      {
        date: "2026-07-16 09:30",
        title: "经营方回应",
        desc: "经营方公开当日菜单与点单记录，说明部分菜品为时令价并按称重结算。",
        type: "官方回应",
      },
      {
        date: "2026-07-18 11:00",
        title: "景区与属地部门介入",
        desc: "景区管理方要求经营户限期完善明码标价，属地部门表示已介入核实。",
        type: "官方回应",
      },
    ],
    officialResponses: [
      {
        org: "景区管理方",
        date: "2026-07-18",
        content:
          "已要求景区内经营户限期完善菜品价格公示，明码标价、按量计价，并畅通游客投诉渠道。",
      },
      {
        org: "属地市场监管部门",
        date: "2026-07-18",
        content:
          "已对涉事经营户开展核实，提醒消费者保留点单与结算凭证，如遇价格问题可及时投诉。",
      },
    ],
    sources: ["经营方公开记录", "景区管理方说明", "属地部门核实信息"],
    relatedFactCheckIds: ["fc-003"],
    relatedGuideIds: ["guide-3"],
  },
  {
    id: "case-004",
    slug: "community-water-power-outage-screenshot",
    title: "“小区连续停水停电三天”群聊截图扩散，物业与供水方同步澄清",
    category: "网络传言",
    status: "谣言证伪",
    region: "华北某小区",
    heat: 5230,
    publishDate: "2026-06-22",
    updateDate: "2026-06-24",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20photograph%20of%20a%20residential%20building%20utility%20room%20with%20pipes%20and%20water%20meters%2C%20cool%20neutral%20daylight%2C%20muted%20tones%20with%20subtle%20warm%20highlights%2C%20calm%20serious%20mood%2C%20no%20readable%20text%2C%20consistent%20verification%20news%20visual%20style%2C%20high%20detail%2C%20tidy%20composition&width=1200&height=750&seq=case-utility-04&orientation=landscape",
    coverAlt: "小区供水管线与检修记录核验（示意画面）",
    summary:
      "一张声称“连续停水停电三天”的群聊截图在多个小区群传播，并附有未署名的“通知”样式图片。物业与供水方随后说明检修安排，截图说法与实际情况不符。",
    verdict: "谣言证伪",
    conclusion:
      "物业与供水方均公开了检修计划与实际供水记录，不存在连续三天停水停电。截图中的“通知”为旧信息被修改日期后重新传播。",
    keyFacts: [
      "实际检修时长为 4 小时，非连续三天",
      "截图中的“通知”为旧版本被修改日期",
      "供水方公布了当日供水压力记录",
    ],
    timeline: [
      {
        date: "2026-06-22 08:00",
        title: "群聊截图扩散",
        desc: "一张“连续停水停电三天”的群聊截图在多个小区群传播，配文称“赶紧储水”。",
        type: "爆料",
      },
      {
        date: "2026-06-23 14:00",
        title: "物业回应",
        desc: "物业说明仅有一次 4 小时计划检修，并公布了检修通知与时间安排。",
        type: "官方回应",
      },
      {
        date: "2026-06-24 10:30",
        title: "核验结论公布",
        desc: "供水方提供当日供水记录，截图中的“通知”被确认为旧信息修改日期后重新传播。",
        type: "核验",
      },
    ],
    officialResponses: [
      {
        org: "小区物业",
        date: "2026-06-23",
        content: "本小区近期仅有一次计划检修，时长约 4 小时，已提前通过公告栏与群消息告知。",
      },
      {
        org: "供水单位",
        date: "2026-06-24",
        content: "当日供水压力记录正常，不存在连续停水情况，请以官方公告为准。",
      },
    ],
    sources: ["物业检修通知", "供水单位记录", "截图版本比对"],
    relatedFactCheckIds: ["fc-004", "fc-005"],
    relatedGuideIds: ["guide-2", "guide-6"],
  },
  {
    id: "case-005",
    slug: "delivery-rider-wage-video-pending",
    title: "“外卖骑手集体被欠薪”短视频热传，多方说法尚待核实",
    category: "求证实录",
    status: "待核验",
    region: "华中某市",
    heat: 7060,
    publishDate: "2026-09-02",
    updateDate: "2026-09-06",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20photograph%20of%20an%20empty%20city%20street%20at%20dusk%20with%20delivery%20bags%20resting%20on%20a%20scooter%20seat%2C%20warm%20muted%20dusk%20tones%2C%20soft%20natural%20light%2C%20calm%20reflective%20mood%2C%20no%20readable%20text%2C%20consistent%20verification%20news%20visual%20style%2C%20high%20detail%2C%20balanced%20composition&width=1200&height=750&seq=case-rider-05&orientation=landscape",
    coverAlt: "外卖配送结算争议信息核验（示意画面）",
    summary:
      "一段声称“骑手集体被欠薪”的短视频引发关注，视频中仅出现结算页面局部。目前平台方、站点与骑手说法存在差异，事件仍在核实中。",
    verdict: "待核验",
    conclusion:
      "现有材料仅包含一段局部录屏与若干聊天记录，尚不足以支持或推翻“集体欠薪”的说法。建议等待平台方结算明细与站点用工关系的进一步说明，我们将在信息更新后同步核验进展。",
    keyFacts: [
      "视频仅显示结算页面局部，缺少完整周期明细",
      "平台方、站点与骑手三方说法存在差异",
      "暂未获取到可验证的完整结算凭证",
    ],
    timeline: [
      {
        date: "2026-09-02 19:10",
        title: "短视频引发关注",
        desc: "一段声称骑手遭遇集体欠薪的短视频在网络传播，画面为结算页面局部录屏。",
        type: "爆料",
      },
      {
        date: "2026-09-04 10:00",
        title: "平台方初步说明",
        desc: "平台方表示正在核查相关站点结算记录，暂未确认存在集体欠薪情况。",
        type: "官方回应",
      },
      {
        date: "2026-09-06 16:00",
        title: "核验进行中",
        desc: "核验人员联系到部分骑手与站点，双方对结算周期与用工关系的表述存在差异，仍在核实。",
        type: "核验",
      },
    ],
    officialResponses: [
      {
        org: "配送平台",
        date: "2026-09-04",
        content: "已启动对相关站点结算记录的核查，将在核实完成后公布结果，保障骑手合法权益。",
      },
    ],
    sources: ["平台方初步说明", "骑手与站点沟通记录", "结算页面录屏"],
    relatedFactCheckIds: ["fc-006"],
    relatedGuideIds: ["guide-5", "guide-6"],
  },
  {
    id: "case-006",
    slug: "vaccine-appointment-sms-screenshot",
    title: "“预约接种需点击短信链接缴费”截图流传，官方提醒谨防仿冒",
    category: "辟谣速览",
    status: "谣言证伪",
    region: "全国范围",
    heat: 8890,
    publishDate: "2026-05-18",
    updateDate: "2026-05-20",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20photograph%20of%20a%20smartphone%20lying%20on%20a%20plain%20desk%20next%20to%20a%20paper%20form%20and%20a%20pen%2C%20soft%20neutral%20daylight%2C%20muted%20tones%2C%20calm%20warning%20mood%2C%20screen%20intentionally%20blank%20with%20no%20readable%20text%2C%20consistent%20fact-check%20visual%20style%2C%20high%20detail%2C%20clean%20composition&width=1200&height=750&seq=case-sms-06&orientation=landscape",
    coverAlt: "仿冒预约短信截图核验（示意画面）",
    summary:
      "一张“预约接种需点击短信链接缴费”的截图在亲友群传播。经核对官方渠道，正规预约不需要通过陌生链接缴纳任何费用，该信息被判定为仿冒。",
    verdict: "谣言证伪",
    conclusion:
      "官方渠道明确，正规预约接种不通过陌生短信链接收费。截图中提到的链接与官方地址不符，属于仿冒信息，提醒公众不要点击、不要填写个人信息。",
    keyFacts: [
      "正规预约接种不通过陌生短信链接收费",
      "截图中链接地址与官方渠道不一致",
      "同类截图曾在多地出现，仅更换机构名称",
    ],
    timeline: [
      {
        date: "2026-05-18 09:00",
        title: "截图在亲友群传播",
        desc: "截图称预约接种需点击短信链接缴费，引发部分居民询问。",
        type: "爆料",
      },
      {
        date: "2026-05-19 11:00",
        title: "官方渠道提醒",
        desc: "官方渠道发布提醒，正规预约不通过陌生链接收费，请勿点击可疑链接。",
        type: "官方回应",
      },
      {
        date: "2026-05-20 15:00",
        title: "核验结论公布",
        desc: "比对链接地址与官方渠道后确认该信息为仿冒，属于谣言。",
        type: "核验",
      },
    ],
    officialResponses: [
      {
        org: "卫生健康服务渠道",
        date: "2026-05-19",
        content: "正规预约接种不通过陌生短信链接缴纳费用，请通过官方渠道预约并核实信息。",
      },
    ],
    sources: ["官方渠道提醒", "链接地址比对", "多地同类截图"],
    relatedFactCheckIds: ["fc-005", "fc-006"],
    relatedGuideIds: ["guide-3", "guide-6"],
  },
  {
    id: "case-007",
    slug: "bus-route-adjustment-rumor",
    title: "“多条公交线路临时改线”传闻扩散，运营方公布实际调整方案",
    category: "官方回应",
    status: "官方已回应",
    region: "东南某市",
    heat: 3980,
    publishDate: "2026-04-26",
    updateDate: "2026-04-28",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20photograph%20of%20a%20city%20bus%20stop%20shelter%20with%20a%20blank%20route%20board%20under%20soft%20morning%20light%2C%20muted%20urban%20tones%2C%20calm%20orderly%20mood%2C%20no%20readable%20text%20or%20logos%2C%20consistent%20verification%20news%20visual%20style%2C%20high%20detail%2C%20balanced%20composition&width=1200&height=750&seq=case-bus-07&orientation=landscape",
    coverAlt: "公交线路调整信息核验（示意画面）",
    summary:
      "一则“多条公交线路临时改线”的消息在通勤群传播，与运营方实际公布的调整方案存在出入。运营方随后发布完整通告，澄清改线范围。",
    verdict: "官方已回应",
    conclusion:
      "运营方公布的调整方案仅涉及两条线路的部分站点，传闻中“多条线路大面积改线”的说法与通告不符。以运营方发布的信息为准即可。",
    keyFacts: [
      "实际仅两条线路部分站点调整",
      "传闻扩大了调整线路数量与范围",
      "运营方已发布完整通告",
    ],
    timeline: [
      {
        date: "2026-04-26 07:30",
        title: "改线传闻在通勤群传播",
        desc: "一则称多条公交线路临时改线的消息在通勤群流传，未附官方来源。",
        type: "爆料",
      },
      {
        date: "2026-04-27 09:00",
        title: "运营方发布通告",
        desc: "运营方公布实际调整方案，仅涉及两条线路的部分站点。",
        type: "官方回应",
      },
      {
        date: "2026-04-28 14:00",
        title: "核验结论公布",
        desc: "比对通告与传闻，确认传闻扩大了改线范围，应以官方通告为准。",
        type: "核验",
      },
    ],
    officialResponses: [
      {
        org: "公交运营方",
        date: "2026-04-27",
        content: "本次线路调整仅涉及两条线路的部分站点，具体以运营方发布的通告为准。",
      },
    ],
    sources: ["运营方通告", "通勤群截图比对"],
    relatedFactCheckIds: ["fc-002", "fc-005"],
    relatedGuideIds: ["guide-2", "guide-3"],
  },
  {
    id: "case-008",
    slug: "trendy-spot-fee-reversal",
    title: "“网红打卡地开始收费”爆料刷屏，现场公示信息还原真相",
    category: "反转追踪",
    status: "反转成立",
    region: "西北某地",
    heat: 5640,
    publishDate: "2026-03-14",
    updateDate: "2026-03-17",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20landscape%20photograph%20of%20a%20quiet%20open%20outdoor%20viewpoint%20with%20a%20simple%20wooden%20railing%20and%20wide%20sky%2C%20muted%20warm%20neutral%20tones%2C%20soft%20golden%20light%2C%20calm%20contemplative%20mood%2C%20no%20people%20and%20no%20readable%20text%2C%20consistent%20verification%20news%20visual%20style%2C%20high%20detail%2C%20expansive%20composition&width=1200&height=750&seq=case-spot-08&orientation=landscape",
    coverAlt: "网红打卡地收费公示信息核验（示意画面）",
    summary:
      "一则“网红打卡地开始收费”的爆料在网络刷屏，配图中出现疑似收费牌。现场公示信息与走访记录显示，收费与免费区域划分明确，爆料对范围存在误读。",
    verdict: "反转成立",
    conclusion:
      "现场公示信息显示，仅一处配套观景平台收取维护费用，主体区域仍免费开放。爆料将局部收费表述为“全面收费”，属于对公示信息的误读，事件出现反转。",
    keyFacts: [
      "仅配套观景平台收取维护费用",
      "主体区域仍免费开放",
      "爆料配图截取了公示信息的一部分",
    ],
    timeline: [
      {
        date: "2026-03-14 12:00",
        title: "收费爆料刷屏",
        desc: "爆料称网红打卡地开始全面收费，配图中出现疑似收费公示牌局部。",
        type: "爆料",
      },
      {
        date: "2026-03-15 16:00",
        title: "管理方回应",
        desc: "管理方说明仅配套观景平台收取维护费用，主体区域仍免费开放。",
        type: "官方回应",
      },
      {
        date: "2026-03-17 11:00",
        title: "核验结论公布",
        desc: "走访现场比对公示信息后确认，爆料对收费范围存在误读，事件反转。",
        type: "反转",
      },
    ],
    officialResponses: [
      {
        org: "打卡地管理方",
        date: "2026-03-15",
        content: "仅观景平台收取必要的维护费用，主体游览区域仍免费开放，相关信息以现场公示为准。",
      },
    ],
    sources: ["现场公示信息", "走访记录", "管理方说明"],
    relatedFactCheckIds: ["fc-003"],
    relatedGuideIds: ["guide-1", "guide-4"],
  },
];

export const getCaseBySlug = (slug: string): CaseItem | undefined =>
  cases.find((item) => item.slug === slug);

export const getFeaturedCase = (): CaseItem => cases[0];

export const getRelatedCases = (current: CaseItem, limit = 3): CaseItem[] =>
  cases.filter((item) => item.id !== current.id).slice(0, limit);